import { useUserClientsWithActiveClient } from 'domains/auth/UserClientsWrapper/useUserClients';
import { useContact } from 'domains/contact/hooks';
import { useMemo } from 'react';

const JOTFORM_SUPPORT_CASE = 'https://forms.expressable.com/243526455920963';

const useOpenSupportCase = () => {
    const { activeClientId } = useUserClientsWithActiveClient();
    const { data: contact } = useContact();

    const url = useMemo(() => {
        if (!contact) {
            return '';
        }

        const params = new URLSearchParams({
            contact: contact.contactID,
            client: activeClientId,
            user: contact.email,
            cf: contact.contactFirstName,
            cl: contact.contactLastName,
        });

        return `${JOTFORM_SUPPORT_CASE}?${params.toString()}`;
    }, [activeClientId, contact]);

    return { url }
};

export default useOpenSupportCase;
